module.exports = __webpack_public_path__ + "static/expert-2@2x-473b5a58169e914177197e4f310c266f.png";